import React from "react";
import { Col, Layout, Row, Space, Tabs, Typography } from "antd";
import { RouteComponentProps } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import TermsAndConditionsAnnouncementsService from "@services/TermsAndCconditionsAnnouncements.services";
import Loader from "@appComponents/Loader/Loader";
import { AgreementsConfig } from "@bundles/consts";
import { TermsTypes } from "@appInterfaces/agreements";

import * as styles from "./style.module.scss";

const TermsWrapper = ({ html, title, id, header, version }: { html: string; title: string; id: number, header: string, version: number }) => (
  <>
    <Typography.Title className={styles.pageTitle} level={4}>
      {title}
    </Typography.Title>
    <div className={styles.termsWrapperHeader}>
      <p>Last updated: {header}</p>
      <p>Version: {version}</p>
    </div>
    <div className={styles.termsWrapper}>{ReactHtmlParser(html)}</div>
  </>
);

type TermsAndConditions = {
  description: string;
  full_content: string;
  header: string;
  id: 5;
  type: TermsTypes;
  version: number;
};

type Props = { userSignedIn: boolean } & RouteComponentProps<{ type?: string }>;

const TermsAndConditionsApp = (props: Props) => {
  const [activeTab, setActiveTab] = React.useState("1");
  const [terms, setTerms] = React.useState<TermsAndConditions[]>([]);

  React.useEffect(() => {
    if (props.match.params.type) {
      setActiveTab(AgreementsConfig[props.match.params.type].key ?? "1");
    }

    TermsAndConditionsAnnouncementsService.get().then((resp) => {
      const types = Object.keys(AgreementsConfig);
      setTerms(
        (resp.data as TermsAndConditions[]).sort(
          (a, b) => types.indexOf(a.type) - types.indexOf(b.type)
        )
      );
    });
  }, []);

  const itemData = (term: TermsAndConditions) => ({
    label: AgreementsConfig[term.type].label,
    key: AgreementsConfig[term.type].key,
    active: AgreementsConfig[term.type].active,
    children: (
      <TermsWrapper
        html={term.full_content}
        title={AgreementsConfig[term.type].label}
        id={term.id}
        header={term.header}
        version={term.version}
      />
    ),
    visible:
      !AgreementsConfig[term.type].private ||
      (props.userSignedIn && AgreementsConfig[term.type].private),
  });

  if (terms.length === 0) {
    return <Loader />;
  }

  return (
    <Space className={styles.wrapper} direction="vertical" size={[0, 48]}>
      <Layout className={styles.layout}>
        <Layout.Content className={styles.container}>
          <Row>
            <Col span={24}>
              <Typography.Title className={styles.pageTitle}>
                Terms and Conditions
              </Typography.Title>
              <Tabs
                tabPosition={"left"}
                defaultActiveKey={activeTab}
                activeKey={activeTab}
                onTabClick={(key: string) => setActiveTab(key)}
                items={terms
                  .map((term) => itemData(term))
                  .filter((term) => term.visible)
                  .filter((term) => term.active)}
              />
            </Col>
          </Row>
        </Layout.Content>
      </Layout>
    </Space>
  );
};

export default (props: Props) => <TermsAndConditionsApp {...props} />;
